export default __webpack_public_path__ + "static/wag_dog_desktop_ie-149d3012c41ff69f751568585e99ee7a.png";